import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useAuth } from "../context/connectionContext";
import { useUserData } from "../context/userContext";
import LoadingPage from "../components/LoadingPage";
import PageHeader from "../components/page_header/PageHeader";
import WrapperUserLoaderWithChildren from "../components/WrapperUserLoaderWithChildren";
import ConnectWalletPrompt from "../components/ConnectWalletPrompt";
import RecoveryMode from "../components/RecoveryMode";

const ProtectedRoute: React.FC = () => {
  const { isConnected, connect, isLoading, account } = useAuth();
  const { safes, status, isInRecovery } = useUserData();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnected && !isLoading) {
      connect();
    }
  }, [isLoading, isConnected, connect]);

  useEffect(() => {
    if (status === "noProfile") {
      navigate(`/create/profile/${account}`);
    }
  }, [safes, navigate, status, account]);

  if (!isLoading && !isConnected) {
    return <ConnectWalletPrompt onConnect={connect} />;
  }

  if (isInRecovery) {
    return <RecoveryMode />;
  }
  return isLoading && safes.length === 0 ? (
    <LoadingPage message="Loading" />
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }}
    >
      <PageHeader />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <WrapperUserLoaderWithChildren>
          <Outlet />
        </WrapperUserLoaderWithChildren>
      </Box>
    </Box>
  );
};

export default ProtectedRoute;
